import { faSpinner } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { twJoin } from "tailwind-merge";

import { getFileTypeStyle } from "src/base-components/fileTypeStyles";

type Props = {
  contentType?: string | null;
  /** sm = composer chip (20px), md = message card (40px). */
  size: "sm" | "md";
  isUploading?: boolean;
  /** Dims the tile to match a disabled host surface. */
  disabled?: boolean;
};

/** File-type icon on a tinted rounded square, shared by file surfaces. */
export const FileTypeTile: React.FC<Props> = ({
  contentType,
  size,
  isUploading = false,
  disabled = false,
}) => {
  const { icon, iconClass, tileClass } = getFileTypeStyle(contentType);

  return (
    <span
      className={twJoin(
        "flex shrink-0 items-center justify-center",
        size === "sm" && "h-5 w-5 rounded",
        size === "md" && "h-10 w-10 rounded-lg",
        isUploading ? "bg-gray-100" : tileClass,
        disabled && "opacity-75",
      )}
    >
      <FontAwesomeIcon
        className={twJoin(
          size === "sm" ? "h-3 w-3" : "h-4 w-4",
          isUploading ? "text-gray-500" : iconClass,
        )}
        icon={isUploading ? faSpinner : icon}
        spin={isUploading}
      />
    </span>
  );
};
